"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordCompletion = recordCompletion;
function recordCompletion(config) {
    var _a, _b;
    if (!((_b = (_a = config === null || config === void 0 ? void 0 : config.firekit) === null || _a === void 0 ? void 0 : _a.run) === null || _b === void 0 ? void 0 : _b.completed)) {
        config.firekit.finishRun();
    }
}
